import computedBehavior from '../../../behaviors/miniprogram-computed'

Component({
  externalClasses: ['custom-class'],
  properties: {
    icon: {
      type: String,
      value: ''
    },
    size: {
      type: String,
      value: ''
    },
    color: {
      type: String,
      value: ''
    },
  },
  /**
   * 类似于mixins和traits的组件间代码复用机制
   */
  behaviors: [computedBehavior],
  computed: {
    iconStyle (): string {
      return `
        font-size: ${this.data.size};
        color: ${this.data.color}
      `
    }
  }
} as any)
